import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ProjectRelatedData } from '../../shared/dto/EntityRepository';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';

interface RelatedProjectProps {
  index: number;
  data: ProjectRelatedData;
}

const RelatedProject: React.FC<RelatedProjectProps> = ({ index, data }) => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);

  if (!pageOwner) return null;

  return (
    <RelatedProjectWrapper to={`/@${pageOwner.handle}/projects/${data.id}`} $isPublic={data.isPublic}>
      - <RelatedProjectTitle>{data.title}</RelatedProjectTitle>
    </RelatedProjectWrapper>
  );
};

const RelatedProjectWrapper = styled(Link)<{ $isPublic: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  ${({ theme }) => theme.typography.Body_04};
  opacity: ${({ $isPublic }) => $isPublic ? 1 : 0.6};
`;

const RelatedProjectTitle = styled.span`
  flex: 1;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
  font-style: oblique;
  &:hover {
    text-decoration: underline;
    transform: scale(1.01);
  }
  transition: all 0.3s ease-in-out;
  cursor: pointer;
`;

export default RelatedProject;
